import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import lrz from 'lrz'
import '@/styles/index.scss' // global css
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);
import App from './App'
import store from './store'
import router from './router'
// Vue.forceUpdate()
import '@/icons' // icon
import '@/permission' // permission control
import i18n from './lang'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


Vue.prototype.noScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}

//弹出框可以滑动
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
}

Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)


import { Button,SwipeItem,Swipe,Lazyload} from 'vant';
import '@vant/touch-emulator';
// 注册为全局可用组件
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Lazyload);
// import "./utils/vant.js";


Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
